export default __webpack_public_path__ + "static/media/linkedinLogo2.e4f057ee.svg";